import { Color } from 'src/utils/theme';

export const LIC_COLORS_DARK = {
  learn: 'success40' as Color,
  immerse: 'error60' as Color,
  communicate: 'information50' as Color,
};
